
import { defineComponent } from "vue";

export default defineComponent({
  name: "ConfirmModal",
  props: {
    message: {
      type: String,
      default: "Vous confirmez cette action ?",
    },
  },
  methods: {
    closeModal() {
      this.$emit("closeConfirmModal");
    },
    confirmAction() {
      this.$emit("callback");
    },
  },
});
